import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { capitalize } from '@material-ui/core';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useMobileLayout from 'Hooks/useMobileLayout';

export const WIDTHS = [
  'xxs',
  'xs',
  'sm',
  'md',
  'lg',
  'smallPhoneWidth',
  'default',
];


const getWidth = (width) => {
  return {
    minWidth: width,
    maxWidth: width,
  };
};

// NOTE: All of these styles were taken from Facebook's left list. Please be mindful if messing with them.
const styles = theme => ({
  root: {
    position: 'sticky',
    top: theme.heights.advisorNavigationHeight,
    overflowY: 'hidden',
    flexShrink: 9999, // If anything is shrinking it's me and I'm getting impossibly small.
    height: '100%',
    overflowX: 'hidden',
    zIndex: 0,
    minHeight: 'inherit',
    display: 'block',
    borderRadius: '16px',
  },
  rootWidthXxs: getWidth(theme.dimensions.xxs),
  rootWidthXs: getWidth(theme.dimensions.xs),
  rootWidthSm: getWidth(theme.dimensions.sm),
  rootWidthMd: getWidth(theme.dimensions.md),
  rootWidthLg: getWidth(theme.dimensions.lg),
  rootWidthDefault: getWidth(theme.dimensions.smallPhoneWidth),
  rootDesktop: {},
  rootMobile: {
    flexBasis: '100%',
  },
  inner1: {
    position: 'relative',
    display: 'flex',
    zIndex: 0,
    height: 'inherit',
    flexDirection: 'column',
  },
  inner2: {
    height: 'inherit',
    overflowX: 'hidden',
    position: 'relative',
    display: 'flex',
    flexShrink: 1,
    overflowY: 'auto',
    zIndex: 0,
    flexBasis: '100%',
    flexDirection: 'column',
    overscrollBehaviorY: 'contain',
    flexGrow: 1,
  },
});

const SideColumn = React.forwardRef(({
  className,
  classes,
  innerClassName,
  children,
  width,
  ...rest
}, ref) => {
  const isMobile = useMobileLayout();
  return (
    <Box
      className={classNames(classes.root, className, {
        [classes[`rootWidth${capitalize(width)}`]]: !isMobile,
        [classes.rootDesktop]: !isMobile,
        [classes.rootMobile]: isMobile,
      })}
      ref={ref}
      {...rest}
    >
      <div className={classes.inner1}>
        <div className={classNames(classes.inner2, innerClassName)}>
          {children}
        </div>
      </div>
    </Box>
  );
});

SideColumn.defaultProps = {
  className: '',
  children: null,
  innerClassName: '',
  width: 'default',
};

SideColumn.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  innerClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  width: PropTypes.oneOf(WIDTHS),
};

export default withStyles(styles)(SideColumn);
